"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    CaseManagerStudent: 'case_manager_student',
    StrategistStudent: 'strategist_student',
    HeadTutorTutor: 'head_tutor_tutor',
    ReviewerStudent: 'reviewer_student',
    GuardianStudent: 'guardian_student',
    AcademicAdvisorStudent: 'academic_advisor_student',
};
//# sourceMappingURL=userRelationship.js.map